/* eslint-disable require-jsdoc */
import {defaultImg} from '../../../utils/defaultImg';
import {isValid, isHttps, removeTrailingStr} from '../../../utils/validate';

function getVenueImage(image) {
  const validImg = isValid(image);
  return validImg ? image : defaultImg();
}

function getVenuePhone(phone) {
  const validPhone = isValid(phone);
  const phoneHtml = ` Call venue ${phone} or`;
  return validPhone ? phoneHtml : '';
}
function hasVenueContact(venue) {
  const validPhone = isValid(venue.phone);
  const validLink = isValid(venue.venueWebsite);
  return !validLink && !validPhone ? false : true;
}
function getSanitizedWebsite(website) {
  const https = isHttps(website);
  const noPrefix = https ? website.substring(8) : website.substring(7);
  const noPostfix = removeTrailingStr(noPrefix, '/');
  return noPostfix;
}
function getVenueWebsite(website) {
  if (!isValid(website)) {
    return '';
  }
  const fullWebsite = website;
  const sanitizedWebsite = getSanitizedWebsite(website);
  return `<a href="${fullWebsite}" target="_blank">${sanitizedWebsite}</a>`;
}
function getVenueContactHtml(venue) {
  if (!hasVenueContact(venue)) {
    return '';
  }
  const venuePhone = getVenuePhone(venue.phone);
  const venueWebsite = getVenueWebsite(venue.venueWebsite);

  return `<div class="hearby-event-message">
            <p>
              Given Covid, check with venue for changes. 
              ${venuePhone}<br>${venueWebsite}
            </p>
        </div>`;
}

export {getVenueImage, getVenueContactHtml};
